import PropTypes from "prop-types";
import { useContext } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import { GeoContext } from "../../context/GeoProvider";
import { withALErrorBoundary } from "../../helpers/ErrorBoundary/ALErrorBoundary";
import useResponsiveWithHydrationFix from "../../hooks/useResponsiveWithHydrationFix";
import useIsHydrationComplete from "../../hooks/useIsHydrationComplete";

import { Link } from "../al_components/ALLink";
import { ALLoading } from "../ALComponents";

import * as lpImageBlocStyles from "./lpImageStyles.module.scss";

function LPImageContent({ mobileImage, desktopImage, altText, link }) {
  const imageUrl = useResponsiveWithHydrationFix(
    getImage(mobileImage.gatsbyImageData),
    getImage(desktopImage.gatsbyImageData)
  );
  if (link?.title === "empty" || link?.title === "null") {
    return <GatsbyImage image={imageUrl} alt={altText} />;
  }
  return (
    <Link className={lpImageBlocStyles.container_link} to={link?.link?.link}>
      <GatsbyImage
        className={lpImageBlocStyles.container__imageMobile}
        image={getImage(mobileImage.gatsbyImageData)}
        alt={altText}
      />
      <GatsbyImage
        className={lpImageBlocStyles.container__imageDesktop}
        image={getImage(desktopImage.gatsbyImageData)}
        alt={altText}
      />
    </Link>
  );
}

function LPImage({ content }) {
  const { image, isFullPage } = content;
  const { gePriceDetails } = useContext(GeoContext);
  const countryCode = gePriceDetails?.CountryCode;
  const isHydrationComplete = useIsHydrationComplete();

  if (!content) {
    return null;
  }

  return (
    <div
      className={`${lpImageBlocStyles.container} ${
        !isFullPage ? lpImageBlocStyles.container_padding : ""
      } id-${content.contentful_id}`}
    >
      {countryCode !== "US" && !isHydrationComplete ? (
        <ALLoading />
      ) : (
        <LPImageContent
          mobileImage={image.mobileImage}
          desktopImage={image.desktopImage}
          altText={image.altText}
          link={image?.link}
        />
      )}
    </div>
  );
}

LPImage.propTypes = {
  content: PropTypes.shape({
    image: PropTypes.shape({
      altText: PropTypes.string,
      desktopImage: PropTypes.object,
      mobileImage: PropTypes.object,
      link: PropTypes.shape({
        title: PropTypes.string,
        link: PropTypes.shape({
          link: PropTypes.string,
        }),
      }),
    }),
    isFullPage: PropTypes.bool,
    contentful_id: PropTypes.string,
  }),
};

export default withALErrorBoundary({
  name: "LPImage",
  priority: "P3",
})(LPImage);
